import { Skeleton as NutSkeleton } from "@nutui/nutui-react";

export function Skeleton() {
  return <NutSkeleton title animated rows={2} />;
}
export function PlainSkeleton() {
  return <NutSkeleton animated rows={1} />;
}
